import { render, staticRenderFns } from "./TabelaHistoricoInativacao.vue?vue&type=template&id=522d63b4&"
import script from "./TabelaHistoricoInativacao.vue?vue&type=script&lang=js&"
export * from "./TabelaHistoricoInativacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaHistoricoInativacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports